import { AffiliateApi } from "@/api/affiliates";
import { UpdateTrialOfferRequest } from "@/api/affiliates/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useUpdateTrialOffer = ({
  onSuccess,
}: {
  onSuccess: (variables: UpdateTrialOfferRequest) => void;
}) => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate: updateTrialOffer, isPending } = useMutation({
    mutationFn: (body: UpdateTrialOfferRequest) =>
      AffiliateApi.updateTrialOffer(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.AFFILIATE_USER],
      });
      setTimeout(() => {
        notify("Affiliate trial offer is updated!", { type: "success" });
      }, 250);
      onSuccess(variables);
    },
  });

  return {
    updateTrialOffer,
    isUpdateTrialOfferLoading: isPending,
  };
};
